import { useState } from 'react';
import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestGrid() {
  const [activeTab, setActiveTab] = useState('all');
  const latestArticles = articles
    .filter((a) => activeTab === 'all' || a.category === activeTab)
    .slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900">
              最新追踪
            </h2>
            <p className="text-foreground-600 text-sm mt-2">实时更新，不错过任何一个瓜</p>
          </div>
          <div className="flex items-center gap-1.5 overflow-x-auto pb-1">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-4 py-2 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                activeTab === 'all'
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              全部
            </button>
            {categories.slice(0, 5).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveTab(cat.slug)}
                className={`px-4 py-2 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeTab === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {latestArticles.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return (
              <ArticleCard
                key={article.id}
                slug={article.slug}
                title={article.title}
                excerpt={article.excerpt}
                categoryName={cat?.name || article.category}
                imageUrl={article.imageUrl}
                imageUrlCompact={article.imageUrlCompact}
                publishedAt={article.publishedAt}
                views={article.views}
                tags={article.tags}
                featured={article.featured}
                variant="default"
              />
            );
          })}
        </div>

        {latestArticles.length === 0 && (
          <div className="text-center py-12 text-foreground-500 text-sm">
            暂无相关爆料内容
          </div>
        )}
      </div>
    </section>
  );
}